import { useState } from "react";
import { googleSignInUrl, logout, type PublicUser } from "../lib/api";

// Topbar auth affordance:
//   - guest    → "Sign in with Google" button (full-page redirect into the OAuth flow)
//   - signed-in → avatar/name chip with a dropdown for sign-out
//
// Sign-in is a navigation, not a fetch, because it bounces through Google's consent page.

export function AuthBar({ user, onChanged }: { user: PublicUser | null; onChanged: () => void }) {
  const [menuOpen, setMenuOpen] = useState(false);

  if (!user) {
    return (
      <button className="signin-btn" onClick={() => (window.location.href = googleSignInUrl())} title="Sign in to keep your apps across devices">
        <GoogleGlyph />
        Sign in
      </button>
    );
  }

  const label = user.username ? `@${user.username}` : user.displayName ?? "Account";

  async function onSignOut() {
    await logout();
    setMenuOpen(false);
    onChanged();
  }

  return (
    <div className="account-chip-wrap">
      <button className="account-chip" onClick={() => setMenuOpen((o) => !o)}>
        {user.avatarUrl ? (
          <img className="account-avatar" src={user.avatarUrl} alt="" referrerPolicy="no-referrer" />
        ) : (
          <span className="account-avatar account-avatar-fallback">{(label[0] ?? "?").toUpperCase()}</span>
        )}
        <span className="account-label">{label}</span>
      </button>
      {menuOpen && (
        <>
          <div className="account-menu-backdrop" onClick={() => setMenuOpen(false)} />
          <div className="account-menu">
            <div className="account-menu-head">
              <div className="account-menu-name">{user.displayName ?? "Signed in"}</div>
              {user.email && <div className="account-menu-email">{user.email}</div>}
            </div>
            <button className="account-menu-item" onClick={onSignOut}>
              Sign out
            </button>
          </div>
        </>
      )}
    </div>
  );
}

function GoogleGlyph() {
  // Google "G" mark.
  return (
    <svg width="15" height="15" viewBox="0 0 18 18" aria-hidden="true" style={{ marginRight: 2 }}>
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.89 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.34A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.94H.96a9 9 0 0 0 0 8.12l3.01-2.34z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.94l3.01 2.34C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}
